import React, { useEffect } from 'react'

import PurchaseOrderPreviewContainer from '../Previews/PurchaseOrderPreviewContainer'

const PurchaseOrderPreviews = ({ match }) => {
    const { ref_code: refCode } = match.params

    useEffect(() => {
        document.title = `${refCode} Previews | OSH CRM`
    }, [refCode])

    return (
        <PurchaseOrderPreviewContainer refCode={refCode} />
    )
}

export default PurchaseOrderPreviews
